import { Theme, ThemeProvider, createTheme } from '@mui/material';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import "typeface-poppins";
import App from './App';
import { ContextProvider } from './context/SocketContext';
import { UserRoleContextProvider } from './context/UserRoleContext';
import './i18n';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { themeOptions } from './theme/custTheme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme:Theme = createTheme(themeOptions)
root.render(
  // <React.StrictMode>
  <Suspense fallback="loading">
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ContextProvider>
          <UserRoleContextProvider>
            <App />
          </UserRoleContextProvider>
        </ContextProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Suspense>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
